export const EditingTextBody =
  'You can add variables into the text by right-clicking where you want to add a variable. These variables are displayed in the participants interfaces as the relevant variable. e.g #country# would display as "Australia" if Australia was the chosen market for the simulation';
